import InView             from './classes/Inview';
import Pluton             from './classes/Pluton';
import Rellax             from 'rellax';
//import Router             from './classes/Router';

class Na {
    constructor() {
        document.body.scrollTo(0, 0);
        //this.router = new Router();
        this.parts = new Pluton();
        this.inview = InView;

        this.rellax = new Rellax('.rellax');
    }
}

function isCompatible() {
    let compatibilty = true;
    if (!Array.from) compatibilty = false;
    if (!Array.prototype.includes) compatibilty = false;
    if (typeof window.CustomEvent !== "function" ) compatibilty = false;
    if (!window.fetch) compatibilty = false;
    if (!window.Promise) compatibilty = false;
    if(!('classList' in document.createElement('p'))) compatibilty = false;
    if (window.NodeList && !NodeList.prototype.forEach) compatibilty = false;

    if (
        !'IntersectionObserver' in window &&
        !'IntersectionObserverEntry' in window &&
        !'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
        compatibilty = false;
    }
    return compatibilty;

}

window.onYouTubeIframeAPIReady = () => {
    window.dispatchEvent(new CustomEvent('na-youtubeloaded'));
}

window.initMap = () => {
    window.dispatchEvent(new CustomEvent('mapsloaded'));
    window.mapsLoaded = true;
}


window.polyfillLoaded = () => {
    window.dispatchEvent(new CustomEvent('na-polyfillloaded'));
}

window.addEventListener("load", function(event) {
    if(window.polyfill || isCompatible()) window.Na = new Na();
    else window.addEventListener('na-polyfillloaded', () => { window.Na = new Na(); });
});
